import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

interface UseShipperShipmentNotesProps {
  shipmentId: number | undefined;
}

export function useShipperShipmentNotes(props: UseShipperShipmentNotesProps) {
  const { shipmentId } = props;
  const { role } = useRoleContext();

  const url =
    role != null && shipmentId !== undefined
      ? `/shippers/${role.id}/shipments/${shipmentId}/notes`
      : null;

  const { data, loading, error, refetch } = useSwrFetch<ShipperShipmentNote[]>({
    url,
    errorMessage: "Failed to load notes.",
  });

  return {
    notes: data ?? [],
    loading,
    error,
    refetch,
  };
}
